import React, { useEffect, useState } from "react";
import { getProjects } from "../api/client";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utils/imageUtils";


const Projects = ({ settings, lang }) => {
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState("all");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getProjects();
                setProjects(response.data || []);
                setFilteredProjects(response.data || []);
            } catch (error) {
                console.error("Failed to fetch projects:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleFilter = (category) => {
        setActiveCategory(category);
        if (category === "all") {
            setFilteredProjects(projects);
        } else {
            setFilteredProjects(projects.filter(p =>
                (p.sector_en && p.sector_en.toLowerCase().includes(category))
            ));
        }
    };

    const getStatic = (key, fallback) => {
        const staticData = lang === "en" ? settings.en : settings.ar;
        return (staticData && staticData[key]) ? staticData[key] : fallback;
    }

    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    useEffect(() => {
        document.title = getStatic("page_title_projects", "إينوبريدج - مشاريعنا");

        // Update meta description
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
            metaDesc.setAttribute("content", getStatic("meta_description_projects", "إينوبريدج - مشاريعنا"));
        }

        // Update meta keywords
        const metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
            metaKeywords.setAttribute("content", getStatic("meta_keyword_projects", "إينوبريدج - مشاريعنا"));
        }
    }, [lang, settings]);
    const getText = (en, ar) => (lang === "en" ? en : ar);


    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader

    return (
        <>
            <header className="py-5 bg-body header1 header">
                <div className="container py-5 text-center">
                    <div className="layout-h"></div>
                    <h1 className="display-4 fw-bold mb-3" data-aos="fade-up">
                        {getStatic("projects_title", "Our Projects")}
                    </h1>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="100">
                        {getStatic("projects_desc", "Explore our portfolio...")}
                    </p>
                </div>
            </header>

            {/* Categories */}
            <section className="py-5 bg-card">
                <div className="container">
                    <div className="text-center mb-5" data-aos="zoom-in">
                        <h2 className="fw-bold display-6 mb-3">{lang === "en" ? "Browse by category" : "تصفح حسب القسم"}</h2>
                        <p className="text-muted">{getText("Filter projects by category to see our experience", "قم بتصفية المشاريعقم بتصفية المشاريع حسب الاقسام لرؤية خبرتنا")}</p>
                    </div>
                    <div className="row g-3 justify-content-center">
                        {[
                            { en: "All", ar: "الكل", key: "all" },
                            { en: "Finance", ar: "المالية", key: "finance" },
                            { en: "Healthcare", ar: "الصحة", key: "healthcare" },
                            { en: "Retail", ar: "التجزئة", key: "retail" },
                            { en: "Technology", ar: "التقنية", key: "technology" },
                            { en: "Education", ar: "التعليم", key: "education" },
                        ].map((cat) => (
                            <div className="col-lg-2 col-md-4 col-6" key={cat.key} data-aos="fade-up">
                                <button
                                    className={`btn btn-outline-custom w-100 py-3 category-filter ${activeCategory === cat.key ? 'active' : ''
                                        }`}
                                    onClick={() => handleFilter(cat.key)}
                                >
                                    <span className="small fw-bold">
                                        {lang === "en" ? cat.en : cat.ar}
                                    </span>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Projects Grid */}
            <section className="py-5 bg-card">
                <div className="container">
                    <div className="row gy-4 justify-content-center" id="projects-grid">
                        {loading ? (
                            <div className="col-12 py-5 text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            filteredProjects.length > 0 ? (
                                filteredProjects.map((p, i) => (
                                    <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100" key={i}>
                                        <div className="card-custom h-100 p-0 overflow-hidden group shadowP">
                                            <div className="position-relative overflow-hidden">
                                                <Link to={`/project/${p.slug_en}`}>
                                                    <img src={getImageUrl(p.image, 'imgPro')} className="w-100 object-fit-cover" style={{ height: '250px' }} alt="Project" />
                                                    <div className="position-absolute top-0 start-0 m-3 badge bg-primary text-dark">
                                                        {lang === 'en' ? p.sector_en : p.sector_ar}
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="p-4 d-flex flex-column">
                                                <h4 className="fw-bold mb-2">{lang === 'en' ? p.title_en : p.title_ar}</h4>
                                                <p className="text-muted mb-4 flex-grow-1">{lang === 'en' ? p.overview_en : p.overview_ar}</p>
                                                <Link to={`/project/${p.slug_en}`} className="btn btn-outline-custom w-100 mt-auto">
                                                    {getText("View Case Study", "عرض دراسة الحالة")}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (

                                <div className="col-12" data-aos="fade-up">
                                    <div className="card-custom h-100 p-5 overflow-hidden group text-center">
                                        <p className="m-0">{getText("There is no projects at the moment.", "لا توجد مشاريع فى الوقت الحالى")}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </section>
            {/* CTA Section - Start Your Project */}
            <section className="py-5">
                <div className="container py-4">
                    <div className="row align-items-center g-5">

                        {/* LEFT SIDE */}
                        <div className="col-lg-6" data-aos="fade-up">

                            <h2 className="fw-bold display-5 mb-4">
                                {getStatic("project_cta_title", lang === "en" ? "Ready to Start Your Project?" : "هل أنت مستعد لبدء مشروعك؟")}
                            </h2>

                            <p className="lead mb-4">
                                {getStatic("project_cta_desc", lang === "en" ? "Let's transform your vision into reality. Our team is ready to help you achieve your business goals." : "دعنا نحول رؤيتك إلى واقع. فريقنا جاهز لمساعدتك في تحقيق أهداف عملك.")}
                            </p>

                            <div className="row g-4 mb-4">

                                {/* Feature 1 */}
                                <div className="col-md-6">
                                    <div className="d-flex align-items-start">
                                        <i className="ri-checkbox-circle-line text-primary fs-4 me-3 mt-1"></i>
                                        <div>
                                            <h6 className="fw-bold mb-1">
                                                {getStatic("project_cta_f1_title", lang === "en" ? "Expert Team" : "فريق خبراء")}
                                            </h6>
                                            <p className="text-muted small mb-0">
                                                {getStatic("project_cta_f1_desc", lang === "en" ? "Experienced professionals" : "محترفون ذوو خبرة")}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Feature 2 */}
                                <div className="col-md-6">
                                    <div className="d-flex align-items-start">
                                        <i className="ri-checkbox-circle-line text-primary fs-4 me-3 mt-1"></i>
                                        <div>
                                            <h6 className="fw-bold mb-1">
                                                {getStatic("project_cta_f2_title", lang === "en" ? "Proven Results" : "نتائج مثبتة")}
                                            </h6>
                                            <p className="text-muted small mb-0">
                                                {getStatic("project_cta_f2_desc", lang === "en" ? "Track record of success" : "سجل حافل بالنجاح")}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Feature 3 */}
                                <div className="col-md-6">
                                    <div className="d-flex align-items-start">
                                        <i className="ri-checkbox-circle-line text-primary fs-4 me-3 mt-1"></i>
                                        <div>
                                            <h6 className="fw-bold mb-1">
                                                {getStatic("project_cta_f3_title", lang === "en" ? "Agile Approach" : "نهج مرن")}
                                            </h6>
                                            <p className="text-muted small mb-0">
                                                {getStatic("project_cta_f3_desc", lang === "en" ? "Flexible methodology" : "منهجية مرنة")}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Feature 4 */}
                                <div className="col-md-6">
                                    <div className="d-flex align-items-start">
                                        <i className="ri-checkbox-circle-line text-primary fs-4 me-3 mt-1"></i>
                                        <div>
                                            <h6 className="fw-bold mb-1">
                                                {getStatic("project_cta_f4_title", lang === "en" ? "On-Time Delivery" : "التسليم في الوقت المحدد")}
                                            </h6>
                                            <p className="text-muted small mb-0">
                                                {getStatic("project_cta_f4_desc", lang === "en" ? "Meeting deadlines" : "الالتزام بالمواعيد")}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        {/* RIGHT SIDE */}
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="bg-card p-5 shadowP" style={{ borderRadius: "16px" }}>

                                <h4 className="fw-bold mb-4 text-center">
                                    {getStatic("project_cta_form_title", lang === "en" ? "Let's Discuss Your Project" : "دعنا نناقش مشروعك")}
                                </h4>

                                <form>
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control bg-body"
                                            placeholder={lang === "en" ? "Full Name" : "الاسم الكامل"}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <input
                                            type="email"
                                            className="form-control bg-body"
                                            placeholder={lang === "en" ? "Email" : "البريد الإلكتروني"}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <input
                                            type="tel"
                                            className="form-control bg-body"
                                            placeholder={lang === "en" ? "Phone" : "الهاتف"}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control bg-body"
                                            placeholder={lang === "en" ? "Company Name" : "اسم الشركة"}
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <textarea
                                            className="form-control bg-body"
                                            rows="4"
                                            placeholder={lang === "en" ? "Project Details" : "تفاصيل المشروع"}
                                            required
                                        ></textarea>
                                    </div>

                                    <button type="submit" className="btn btn-primary-custom w-100 py-3 fw-bold">
                                        <span>
                                            {getStatic("project_cta_submit", lang === "en" ? "Start Your Project" : "ابدأ مشروعك")}
                                        </span>
                                        <i className="ri-arrow-right-line ms-2"></i>
                                    </button>

                                </form>

                            </div>
                        </div>

                    </div>
                </div>
            </section>


        </>
    );
};

export default Projects;
